import * as React from 'react';
import { ConfigurationContext } from 'Configuration/Context';

export const useConfigurationContext = () => React.useContext(ConfigurationContext);
